import SellerDashboardNew from "../../views/seller/dashboard/SellerDashboardNew";
import Wallet from "../../views/seller/wallet";
import Subscription from "../../views/seller/subscription";
import ProductSubscription from "../../views/seller/productSubscription";
import Settings from "../../views/seller/settings";
import Invoice from "../../views/seller/reports/invoice";
import Orders from "../../views/seller/orders/list";
import FailedOrders from "../../views/seller/orders/failed";
import MarketplaceApis from "../../views/seller/marketPlaceApi";
import OrderDetails from "../../views/seller/orders/details";
import AddOrder from "../../views/seller/orders/add";
import UserProfile from "../../views/seller/profile";
import Ticket from "../../views/admin/Ticket";
import SellerAmazonProductDetail from "../../views/seller/amazonProduct";
// import SellerFlipkartProductDetail from "../../views/seller/flipkartProduct"; // loaded inline on Product Research page
import SellerFindSimilar from "../../views/seller/amazonProduct/FindSimilar";
import SellerProductDetail from "../../views/seller/amazonProduct/ProductDetail";
import SellerProductResearch from "../../views/seller/productResearch";
import AffiliateDashboard from "../../views/affiliate/Dashboard";
import AffiliateMySellers from "../../views/affiliate/MySellers";
import SellerOrderDetails from "../../views/affiliate/SellerOrderDetails";
import AffiliateEarnings from "../../views/affiliate/Earnings";
import AffiliateWithdraw from "../../views/affiliate/Withdraw";
import AffiliateProfile from "../../views/affiliate/Profile";
import FeaturedCategoriesLanding from "../../views/seller/dropshippingProducts";

const sellerRoutes = [
  {
    path: "seller/dashboard",
    element: <SellerDashboardNew />,
  },
  {
    path: "seller/orders",
    element: <Orders />,
  },
  {
    path: "seller/orders/failed",
    element: <FailedOrders />,
  },
  {
    path: "seller/amazon-product",
    element: <SellerAmazonProductDetail />,
  },
  // {
  //   path: "seller/flipkart-product",
  //   element: <SellerFlipkartProductDetail />,
  // },
  {
    path: "seller/find-similar",
    element: <SellerFindSimilar />,
  },
  {
    path: "seller/product-detail",
    element: <SellerProductDetail />,
  },
  {
    path: "seller/product-research",
    element: <SellerProductResearch />,
  },
  {
    path: "seller/orders/addOrder",
    element: <AddOrder />,
  },
  {
    path: "seller/orders/orderDetails/:id",
    element: <OrderDetails />,
  },

  {
    path: "seller/marketplaceApis",
    element: <MarketplaceApis />,
  },

  {
    path: "seller/subscription",
    element: <Subscription />,
  },
  {
    path: "seller/productSubscription",
    element: <ProductSubscription />,
  },
  {
    path: "seller/dropshippingProducts",
    element: <FeaturedCategoriesLanding />,
  },

  {
    path: "seller/wallet",
    element: <Wallet />,
  },
  {
    path: "seller/settings",
    element: <Settings />,
  },
  {
    path: "seller/reports/invoice",
    element: <Invoice />,
  },
  {
    path: "seller/profile",
    element: <UserProfile />,
  },
  {
    path: "seller/affiliate/dashboard",
    element: <AffiliateDashboard />,
  },
  {
    path: "seller/affiliate/sellers/:sellerId/orders",
    element: <SellerOrderDetails />,
  },
  {
    path: "seller/affiliate/sellers",
    element: <AffiliateMySellers />,
  },
  {
    path: "seller/affiliate/earnings",
    element: <AffiliateEarnings />,
  },
  {
    path: "seller/affiliate/withdraw",
    element: <AffiliateWithdraw />,
  },
  {
    path: "seller/affiliate/profile",
    element: <AffiliateProfile />,
  },
  {
    path: "/seller/orders/ticket/:id",
    element: <Ticket />,
  },
];

export default sellerRoutes;
